import { render, staticRenderFns } from "./DuplicateProgramModal.vue?vue&type=template&id=46a62c4f&"
import script from "./DuplicateProgramModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateProgramModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports